// Import the required AWS SDK clients and commands for Node.js
// https://github.com/awsdocs/aws-doc-sdk-examples/tree/main/javascriptv3/example_code/dynamodb
// snippet-start:[dynamodb.JavaScript.movies.putItemV3]
import { GetCommand, PutCommand, QueryCommand  } from "@aws-sdk/lib-dynamodb";
import { ddbDocClient } from "../lib/ddbDocClient.js";

export const updateDynamoDB = async ({ uuidValue, oen, printDate }) => {
  // Set the parameters.
  const params = {
    TableName: "UvaTranscriptTable",
    Item: {
      uuidValue,
      oen,
      printDate,
    },
  };
  try {
    const data = await ddbDocClient.send(new PutCommand(params));
    console.log("Success - item added or updated", data);
  } catch (err) {
    console.log("Error", err.stack);
  }
};


export const queryTable = async ({ uuidValue }) => {
  try {
    const params = {
      IndexName: "uuidValueIndex",
      TableName: "UvaTranscriptTable",
      ExpressionAttributeValues: {
        ":r": uuidValue,
      },
      KeyConditionExpression: "uuidValue = :r",
    };
    const data = await ddbDocClient.send(new QueryCommand(params));
    for (let i = 0; i < data.Items.length; i++) {
      console.log(
        "Found item with OEN: " + data.Items[i].oen 
      );
    }
    return data.Items[0]
  } catch (err) {
    console.log("Error", err);
  }
};

export const getItem = async ({ oen }) => {
  try {
    const params = {
      TableName: "UvaTranscriptTable",
      Key: {
        oen,
      }
    };
    const data = await ddbDocClient.send(new GetCommand(params));
    console.log("Success :", data.Item);
    return data.Item
  } catch (err) {
    console.log("Error", err);
  }
};
